import { Draft, produce } from 'immer';

import * as TYPES from '@app/store/actionTypes';
import {
  scheduledDocumentPreviewDataFetched,
  setTemplateParticipants,
  setupTemplateByDraft,
  TemplateAction,
} from '@app/store/template/actions';

type TemplateIdsState = string[];

const initialState: TemplateIdsState = [];

const reducer = produce((draft: Draft<TemplateIdsState>, action: TemplateAction) => {
  switch (action.type) {
    case TYPES.TEMPLATE_CLEAR_ALL_STATE:
    case TYPES.TEMPLATE_INFORMATION_FETCH_REQUEST:
      return initialState;
    case TYPES.TEMPLATE_INFORMATION_FETCH_SUCCESS:
    case scheduledDocumentPreviewDataFetched.type:
      return action.payload.participants.map((participant) => participant.id);
    case setupTemplateByDraft.type: {
      action.payload.participants.forEach((participant) => draft.push(participant.id));
      return draft;
    }
    case setTemplateParticipants.type: {
      return action.payload.map((participant) => participant.id);
    }
    default:
      return draft;
  }
}, initialState);

export default reducer;
